/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AuthorModel } from './AuthorModel';
import {
    AuthorModelFromJSON,
    AuthorModelFromJSONTyped,
    AuthorModelToJSON,
} from './AuthorModel';
import type { ImageModel } from './ImageModel';
import {
    ImageModelFromJSON,
    ImageModelFromJSONTyped,
    ImageModelToJSON,
} from './ImageModel';
import type { TagModel } from './TagModel';
import {
    TagModelFromJSON,
    TagModelFromJSONTyped,
    TagModelToJSON,
} from './TagModel';

/**
 * コミチプラスで扱われる作品の作品情報の概要です。
 * @export
 * @interface SeriesSummaryModel
 */
export interface SeriesSummaryModel {
    /**
     * コミチ内で作品に付与される一意のID
     * @type {string}
     * @memberof SeriesSummaryModel
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof SeriesSummaryModel
     */
    indexId?: number;
    /**
     * 作品タイトル
     * @type {string}
     * @memberof SeriesSummaryModel
     */
    name: string;
    /**
     * 連載曜日
     * 1〜7の値で曜日情報を示します。月曜日が`1` 日曜日は`7`となります。
     * 空欄("")や`null`が入ることもありますが、その際は`連載曜日情報なし`扱いとなります。
     * @type {string}
     * @memberof SeriesSummaryModel
     */
    daysOfWeek?: string;
    /**
     * 作品の説明
     * @type {string}
     * @memberof SeriesSummaryModel
     */
    description?: string;
    /**
     * 発行日のUNIX時間
     * @type {number}
     * @memberof SeriesSummaryModel
     */
    publishDate?: number;
    /**
     * 更新日のUNIX時間
     * @type {number}
     * @memberof SeriesSummaryModel
     */
    updatedOn?: number;
    /**
     * 待つと無料の残り時間（秒数）
     * @type {number}
     * @memberof SeriesSummaryModel
     */
    waitAndFreeRecoveryTime?: number;
    /**
     * 作品の「待つと無料」チャージが復旧される時間のUNIX時間
     * @type {number}
     * @memberof SeriesSummaryModel
     */
    seriesWaitOn?: number;
    /**
     * 作品の状態。
     * @type {string}
     * @memberof SeriesSummaryModel
     */
    status?: string;
    /**
     * 作品のお気に入り登録数
     * @type {number}
     * @memberof SeriesSummaryModel
     */
    numFavorite?: number;
    /**
     * エピソードのいいね数の合計
     * @type {number}
     * @memberof SeriesSummaryModel
     */
    numLikesTotal?: number;
    /**
     * 
     * @type {Array<AuthorModel>}
     * @memberof SeriesSummaryModel
     */
    author?: Array<AuthorModel>;
    /**
     * 作品画像
     * @type {Array<ImageModel>}
     * @memberof SeriesSummaryModel
     */
    images?: Array<ImageModel>;
    /**
     * true の場合、完結した作品であることを表します。
     * @type {boolean}
     * @memberof SeriesSummaryModel
     */
    isCompleted: boolean;
    /**
     * 0 の場合、html。1の場合、json
     * @type {number}
     * @memberof SeriesSummaryModel
     */
    descriptionType?: number;
    /**
     * 作品内のエピソード数
     * @type {number}
     * @memberof SeriesSummaryModel
     */
    numEpisodes: number;
    /**
     * 作品のタッグ一覧
     * @type {Array<TagModel>}
     * @memberof SeriesSummaryModel
     */
    tag?: Array<TagModel>;
    /**
     * 「更新」の右上の帯
     * @type {boolean}
     * @memberof SeriesSummaryModel
     */
    isUp?: boolean;
    /**
     * 作品のカテゴリ
     * @type {string}
     * @memberof SeriesSummaryModel
     */
    category?: string;
    /**
     * true の場合、キャンペーン中であることを表します
     * @type {boolean}
     * @memberof SeriesSummaryModel
     */
    isOnCampaign?: boolean;
    /**
     * キャンペーン終了時刻のUNIX時間
     * @type {number}
     * @memberof SeriesSummaryModel
     */
    campaignEndDatetime?: number;
    /**
     * 無料話数
     * @type {number}
     * @memberof SeriesSummaryModel
     */
    freeArticleCount?: number;
    /**
     * 待つと無料が始まるエピソードのインデックス
     * @type {number}
     * @memberof SeriesSummaryModel
     */
    waitFreeStartArticleIndex?: number;
    /**
     * 待つと無料が終わるエピソードのインデックス
     * @type {number}
     * @memberof SeriesSummaryModel
     */
    waitFreeEndArticleIndex?: number;
}

/**
 * Check if a given object implements the SeriesSummaryModel interface.
 */
export function instanceOfSeriesSummaryModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "isCompleted" in value;
    isInstance = isInstance && "numEpisodes" in value;

    return isInstance;
}

export function SeriesSummaryModelFromJSON(json: any): SeriesSummaryModel {
    return SeriesSummaryModelFromJSONTyped(json, false);
}

export function SeriesSummaryModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): SeriesSummaryModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'indexId': !exists(json, 'indexId') ? undefined : json['indexId'],
        'name': json['name'],
        'daysOfWeek': !exists(json, 'daysOfWeek') ? undefined : json['daysOfWeek'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'publishDate': !exists(json, 'publishDate') ? undefined : json['publishDate'],
        'updatedOn': !exists(json, 'updatedOn') ? undefined : json['updatedOn'],
        'waitAndFreeRecoveryTime': !exists(json, 'waitAndFreeRecoveryTime') ? undefined : json['waitAndFreeRecoveryTime'],
        'seriesWaitOn': !exists(json, 'seriesWaitOn') ? undefined : json['seriesWaitOn'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'numFavorite': !exists(json, 'numFavorite') ? undefined : json['numFavorite'],
        'numLikesTotal': !exists(json, 'numLikesTotal') ? undefined : json['numLikesTotal'],
        'author': !exists(json, 'author') ? undefined : ((json['author'] as Array<any>).map(AuthorModelFromJSON)),
        'images': !exists(json, 'images') ? undefined : ((json['images'] as Array<any>).map(ImageModelFromJSON)),
        'isCompleted': json['isCompleted'],
        'descriptionType': !exists(json, 'descriptionType') ? undefined : json['descriptionType'],
        'numEpisodes': json['numEpisodes'],
        'tag': !exists(json, 'tag') ? undefined : ((json['tag'] as Array<any>).map(TagModelFromJSON)),
        'isUp': !exists(json, 'isUp') ? undefined : json['isUp'],
        'category': !exists(json, 'category') ? undefined : json['category'],
        'isOnCampaign': !exists(json, 'isOnCampaign') ? undefined : json['isOnCampaign'],
        'campaignEndDatetime': !exists(json, 'campaignEndDatetime') ? undefined : json['campaignEndDatetime'],
        'freeArticleCount': !exists(json, 'freeArticleCount') ? undefined : json['freeArticleCount'],
        'waitFreeStartArticleIndex': !exists(json, 'waitFreeStartArticleIndex') ? undefined : json['waitFreeStartArticleIndex'],
        'waitFreeEndArticleIndex': !exists(json, 'waitFreeEndArticleIndex') ? undefined : json['waitFreeEndArticleIndex'],
    };
}

export function SeriesSummaryModelToJSON(value?: SeriesSummaryModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'indexId': value.indexId,
        'name': value.name,
        'daysOfWeek': value.daysOfWeek,
        'description': value.description,
        'publishDate': value.publishDate,
        'updatedOn': value.updatedOn,
        'waitAndFreeRecoveryTime': value.waitAndFreeRecoveryTime,
        'seriesWaitOn': value.seriesWaitOn,
        'status': value.status,
        'numFavorite': value.numFavorite,
        'numLikesTotal': value.numLikesTotal,
        'author': value.author === undefined ? undefined : ((value.author as Array<any>).map(AuthorModelToJSON)),
        'images': value.images === undefined ? undefined : ((value.images as Array<any>).map(ImageModelToJSON)),
        'isCompleted': value.isCompleted,
        'descriptionType': value.descriptionType,
        'numEpisodes': value.numEpisodes,
        'tag': value.tag === undefined ? undefined : ((value.tag as Array<any>).map(TagModelToJSON)),
        'isUp': value.isUp,
        'category': value.category,
        'isOnCampaign': value.isOnCampaign,
        'campaignEndDatetime': value.campaignEndDatetime,
        'freeArticleCount': value.freeArticleCount,
        'waitFreeStartArticleIndex': value.waitFreeStartArticleIndex,
        'waitFreeEndArticleIndex': value.waitFreeEndArticleIndex,
    };
}

